<!--
Author: TangChen
Date: 2018-11-21
Desc: 基金超市
 -->
<template>
    <div :class="'view-trade-record view ' + className">
        <comp-title :title="title">
            <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/fund' }">
                    基金交易
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb> -->
        </comp-title>
        <div class="trade-record">
            <el-row class="fund-filter">
                <el-col v-if="$cache.getParams().is_zx=='1'" :span="24" class="btn-fund">
                    销售来源：
                    <el-radio-group v-model="fundFrom" size="mini">
                        <el-radio-button v-for="type in fundFromArr" :key="type.val" :label="type.val">
                            {{ type.text }}
                        </el-radio-button>
                    </el-radio-group>
                </el-col>
                <el-col :span="24" class="btn-fund">
                    时间周期：
                    <el-radio-group v-model="tradeTime" size="mini">
                        <el-radio-button v-for="type in tradeTimeArr" :key="type.val" :label="type.val">
                            {{ type.text }}
                        </el-radio-button>
                    </el-radio-group>
                    <div v-if="tradeTime==='6'" class="custom-time">
                        <date-picker :date="dateSet" v-on:date-get="dateInterval" />
                        <el-button size="small" round v-on:click.prevent="searchFund">
                            查询
                        </el-button>
                    </div>
                </el-col>
                <el-col :span="24" class="btn-fund">
                    业务类型：
                    <el-radio-group v-model="tradeCate" size="mini">
                        <el-radio-button v-for="risk in tradeCateArr" :key="risk.val" :label="risk.val">
                            {{ risk.text }}
                        </el-radio-button>
                    </el-radio-group>
                </el-col>
                <el-col :span="24" class="btn-search">
                    查询条件：
                    <span v-for="tag in dynamicTags" :key="tag" style="display:inline-block;">
                        <el-tag v-if="tag" closable :disable-transitions="false" v-on:close="handleClose(tag)">{{ tag }}
                        </el-tag>
                    </span>
                    <el-input
                        v-model="searchText"
                        placeholder="请输入基金名称或基金代码"
                        class="input-search"
                        size="small"
                    />
                    <el-button
                        class="btn-search-icon"
                        icon="el-icon-search"
                        type="primary"
                        size="small"
                        v-on:click="searchFund"
                    />
                </el-col>
            </el-row>
            <el-table
                :data="fund"
                style="width: 100%"
                class="tab-list-tit"
                :row-key="getRowKeys"
                :expand-row-keys="expands"
                v-on:expand-change="expendTable"
            >
                <!-- v-if="fundFrom === '1'" -->
                <!--<el-table-column
                    prop="operdate"
                    label="下单日期"
                    align="center"
                    width="100"
                    :formatter="formatterDate"
                />-->
                <!-- v-if="fundFrom == '1'" -->
                <el-table-column
                    prop="distributorcode"
                    label="销售商名称"
                    align="center"
                    width="200"
                    :formatter="formatterDisname"
                />
                <el-table-column
                    prop="transactiondate"
                    label="交易日期"
                    align="center"
                    width="100"
                    :formatter="formatterDate"
                />
                <el-table-column
                    prop="fundname"
                    label="基金名称"
                    align="center"
                    :formatter="formatterName"
                    width="240"
                />
                <!--<el-table-column
                    v-if="fundFrom !== '1'"
                    prop="targetfundname"
                    label="目标基金名称"
                    align="center"
                    :formatter="formatterNameCC"
                />-->
                <el-table-column
                    prop="businesscode"
                    label="业务类型"
                    align="center"
                    :formatter="formatterTran"
                    width="120"
                />
                <!-- v-if="fundFrom === '1'" -->
                <el-table-column
                    key="appdata"
                    prop="appdata"
                    label="申请金额/份额"
                    align="center"
                    :formatter="formatterAmount"
                ></el-table-column>
                <el-table-column label="确认金额/份额" align="center" :formatter="formatterCfmAmount" width="200"></el-table-column>
                <el-table-column label="处理状态" align="center" :formatter="formatterCfmStatus"></el-table-column>
                <!-- v-if="fundFrom==='1'" -->
                <el-table-column key="detail" label="详情" align="center" fixed="right">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sourceflag === '1'" class="like-a" v-on:click.prevent="detail(scope.row.appsheetserialno)">详情</span>
                        <span v-else></span>
                    </template>
                </el-table-column>
                <!--   <el-table-column
                    v-if="false"
                    v-if="$util.getConfig().hideFunc"
                    key="a"
                    label="操作"
                    align="center"
                    width="100"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="primary"
                            size="small"
                            :disabled="scope.row.cancelflag!=='1'"
                            v-on:click.stop="cancelTrade(scope.row.appsheetserialno)"
                        >
                            撤单
                        </el-button>
                    </template>
                </el-table-column>-->
            </el-table>
            <el-row v-if="Number(allPage) !== 0" class="page-box">
                <el-pagination
                    background
                    :page-sizes="pageSizes"
                    :page-size="Number(pagecount)"
                    :current-page.sync="curPage"
                    :layout="pageLayout"
                    :total="Number(allPage)"
                    v-on:current-change="pageRefresh"
                    v-on:size-change="sizeReset"
                >
                    <el-button type="primary" plain v-on:click="showAll">
                        {{ !isShowAll ? "显示全部" : "分页展示" }}
                    </el-button>
                </el-pagination>
            </el-row>
        </div>
        <el-dialog title="撤单提示" :visible.sync="dialogVisible" class="prop info-tips" width="480px">
            <div class="investor-tips">
                <div class="prompt-info">
                    <p><i class="el-icon-warning" /><span>您是否确定对{{ cancelFund.fundname+'('+cancelFund.fundcode+')['+$cache.getDict('130010',cancelFund.businesscode)+']执行撤单操作'+(isPwdCheck?'，输入交易密码进行撤单':'') }}</span></p>
                </div>
                <el-form
                    ref="ruleForm"
                    class="two-cols-form"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="37px"
                    size="small"
                >
                    <el-form-item v-if="isPwdCheck" label="" prop="tradepwd">
                        <el-input
                            v-model="ruleForm.tradepwd"
                            type="password"
                            :maxlength="20"
                            placeholder="请输入交易密码"
                        />
                        <!-- <span class="redemp-btn" v-on:click.prevent="$router.push({name: 'tradepwd'})"><span class="like-a">忘记密码？</span></span>-->
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-on:click="dialogVisible = false">
                    返回
                </el-button>
                <el-button type="primary" v-on:click="cancelConfirm">
                    撤单
                </el-button>
            </div>
        </el-dialog>
        <el-dialog title="详细信息" :visible.sync="detailVisible" class="prop info-tips trade-detail-dialog" width="1000px">
            <div class="investor-tips">
                <div class="prompt-info">
                    <el-form
                        v-if="fundDetail.appsheetserialno"
                        label-position="left"
                        label-width="140px"
                        inline
                        class="demo-table-expand trade-detail-form"
                    >
                        <el-form-item label="申请单号">
                            <span>{{ fundDetail.appsheetserialno }}</span>
                        </el-form-item>
                        <el-form-item :label="!$util.isEmpty(fundDetail.paystatus)?'支付状态':''">
                            <span>{{ $cache.getDict('110066',fundDetail.paystatus) || "" }}</span>
                        </el-form-item>
                        <el-form-item v-if="fundDetail.transactiondate" label="交易时间">
                            <span>{{
                                $util.fmtDate(fundDetail.transactiondate)/*+'&nbsp;&nbsp;'+fundDetail.transactiontime*/
                            }}</span>
                        </el-form-item>
                        <el-form-item v-if="fundDetail.operdate" label="下单时间">
                            <span>{{
                                $util.fmtDate(fundDetail.operdate)/*+'&nbsp;&nbsp;'+fundDetail.opertime*/ }}</span>
                        </el-form-item>
                        <el-form-item label="基金信息">
                            <span>{{ fundDetail.fundname+'('+fundDetail.fundcode+')' }}</span>
                        </el-form-item>
                        <el-form-item label="业务类型">
                            <span>{{ $cache.getDict('130010',fundDetail.businesscode) }}</span>
                        </el-form-item>
                        <el-form-item v-if="fundDetail.dividendmethod.trim()!==''" label="分红方式">
                            <span>{{ $cache.getDict('110001',fundDetail.dividendmethod) }}</span>
                        </el-form-item>
                        <el-form-item label="银行卡">
                            <span>{{ $cache.getDict('110080',fundDetail.channelid)+'[尾号'+fundDetail.bankcard.substr(-4,4)+']-'+$cache.getDict('110079',fundDetail.paycenterid) }}</span>
                        </el-form-item>
                        <el-form-item label="基金净值">
                            <span>{{ $util.fmtNum(fundDetail.nav,4) }}</span>
                        </el-form-item>
                        <el-form-item v-if="!$util.isEmpty(fundDetail.charge)&&!$util.isEmpty(fundDetail.cfmstatus)" label="手续费">
                            <span>{{ ($util.fmtNum(fundDetail.charge)+'元') }}</span>
                        </el-form-item>
                        <el-form-item v-if="showRefundSalesServiceFee" label="返还销售服务费">
                            <span>{{ ($util.fmtNum(fundDetail.otherfee2)+'元') }}</span>
                        </el-form-item>
                        <el-form-item v-if="showManageFeeFields" label="返还或有管理费">
                            <span>{{ fundDetail.refundcontingentfee ? $util.fmtNum(fundDetail.refundcontingentfee)+'元' : '--' }}</span>
                        </el-form-item>
                        <el-form-item v-if="showManageFeeFields" label="超额管理费">
                            <span>{{ fundDetail.excessmgrfee ? $util.fmtNum(fundDetail.excessmgrfee)+'元' : '--' }}</span>
                        </el-form-item>
                        <el-form-item label="确认金额/份额">
                            <span>{{ fundDetail.cfmamount>0?($util.fmtNum(fundDetail.cfmamount)):($util.fmtNum(fundDetail.cfmevol)) }}</span>
                        </el-form-item>
                        <el-form-item v-if="fundDetail.cfmdate" label="确认日期">
                            <span>{{ $util.fmtDate(fundDetail.cfmdate) }}</span>
                        </el-form-item>
                        <el-form-item v-if="fundFrom==='2'&&fundDetail.distributorcode" label="销售机构">
                            <span>{{ $cache.getDict('110070',fundDetail.distributorcode) }}</span>
                        </el-form-item>
                        <el-form-item v-if="showTargetFundFields" label="目标基金信息">
                            <span>{{ fundDetail.targetfundname+'('+fundDetail.targetfundcode+')' }}</span>
                        </el-form-item>
                        <el-form-item v-if="showTargetFundFields" label="目标基金净值">
                            <span>{{ $util.fmtNum(fundDetail.targetnav,4) }}</span>
                        </el-form-item>
                        <el-form-item v-if="showTargetFundFields" label="目标基金确认份额">
                            <span>{{ $util.fmtNum(fundDetail.targetcfmvol) }}份</span>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <!--<div class="remit-infos" v-on:click="$router.push({'name': 'remitinfo'})">-->
            <!--<span>-->
            <!--查看更多汇款账号信息-->
            <!--</span>-->
            <!--</div>-->
            <div slot="footer" class="dialog-footer">
                <el-button type="blue" v-on:click="detailVisible = false">
                    关闭
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import format from "date-fns/format";

import mixin from "@/assets/js/mixin";
import datePicker from "@/components/common/datePicker";

const MANAGE_FEE_BUSINESS_CODES = ["24", "36", "63"];
const TARGET_FUND_BUSINESS_CODES = ["36", "D2", "69"];
const TARGET_FUND_BUSINESS_KINDS = ["2", "6"];

function isManageFeeBusiness(record = {}) {
    return MANAGE_FEE_BUSINESS_CODES.includes(record.businesscode);
}

function isTargetFundBusiness(record = {}) {
    return TARGET_FUND_BUSINESS_CODES.includes(record.businesscode) ||
        (record.businesscode === "24" && TARGET_FUND_BUSINESS_KINDS.includes(record.businesskind));
}

export default {
    name: "TradeRecord",
    components: {
        datePicker
    },
    mixins: [mixin],
    data () {
        return {
            curPage: 1,
            expands: [],
            tradeTime: "",
            tradeCate: "",
            searchText: "",
            fund: [],
            dynamicTags: [],
            endDate: "",
            beginDate: "",
            nowDate: "", // 当前时间
            pagecount: "",
            pageoffset: "0",
            allPage: "0",
            queryFind: null,
            fundFrom: "3",
            query: null,
            index: 0,
            fundFromArr: [
                { val: "3", text: "全部" },
                { val: "1", text: "直销" },
                { val: "2", text: "代销" }
            ],
            tradeCateArr: [// 业务类型
                { val: "", text: "全部" },
                { val: "20,22", text: "认/申购" },
                { val: "24", text: "赎回" },
                { val: "36", text: "转换" },
                // { val: "59,39,60", text: "定投" },
                { val: "29", text: "修改分红方式" }
            ],
            tradeTimeArr: [// 时间周期
                { val: "1", text: "近7天" },
                { val: "2", text: "近一个月" },
                { val: "3", text: "近三个月" },
                { val: "4", text: "近半年" },
                { val: "5", text: "近一年" },
                { val: "6", text: "自定义" }
            ],
            fundDetail: {},
            dialogVisible: false,
            detailVisible: false,
            isPwdCheck: false,
            // 撤单密码校验
            ruleForm: {
                tradepwd: ""
            },
            rules: {
                tradepwd: [
                    { required: true, message: "请输入交易密码", trigger: "blur" }
                ]
            },
            cancelFund: {},
            dateSet: { type: "2", min: "1990-01-01", size: "mini" },
            hadDX: false, //是否购买增值模块整合代销数据，默认未购买
            signArray: [],
            isShowAll: false,
            pageSizes: [20, 50, 100],
            pageLayout: "total, slot, sizes, prev, pager, next"
        };
    },
    computed: {
        showRefundSalesServiceFee () {
            return this.showManageFeeFields && !this.$util.isEmpty(this.fundDetail.otherfee2);
        },
        showManageFeeFields () {
            return isManageFeeBusiness(this.fundDetail);
        },
        showTargetFundFields () {
            return isTargetFundBusiness(this.fundDetail);
        }
    },
    watch: {
        // 监测选项变化
        tradeCate (val,old) {
            this.pageoffset = "0";
            this.curPage = 1;
            this.doAction();
        },
        fundFrom (val,old) {
            this.pageoffset = "0";
            this.curPage = 1;
            this.doAction();
        },
        tradeTime (val,old) {
            this.endDate = this.nowDate;
            const _x = new Date(this.$util.fmtDate(this.nowDate)).getTime();
            if (val === "1") {
                this.beginDate = format(_x - 7 * 24 * 3600 * 1000, "YYYYMMDD");
            } else if (val === "2") {
                this.beginDate = this.$util.getBeginDate(this.nowDate, 1);
            } else if (val === "3") {
                this.beginDate = this.$util.getBeginDate(this.nowDate, 3);
            } else if (val === "4") {
                this.beginDate = this.$util.getBeginDate(this.nowDate, 6);
            } else if (val === "5") {
                this.beginDate = this.$util.getBeginDate(this.nowDate, 1, true);
            } else if (val === "6") {
                this.fund = [];
                this.allPage = 0;
                this.endDate = "";
                this.beginDate = "";
                return;
            }
            this.pageoffset = "0";
            this.doAction();
        }
    },
    created () {
        //this.fundFrom = this.$cache.getParams().is_zx == "1" ? "1" : "2";
        /*this.hadDX = this.$cache.getStatus("DX") == "1" ? true : false;
        if(this.hadDX){
            this.fundFromArr = [
                { val: "1", text: "直销" },
                { val: "2", text: "代销" }
            ];
        }*/
        this.tradeCate = this.$route.query.way ? this.$route.query.way : "";
        this.isPwdCheck = this.$cache.getPwdCheck("C1");
        this.nowDate = format(new Date(), "YYYYMMDD");
        this.pagecount = "20";//this.$util.getConfig().const.PAGE_SIZE;
        this.dateSet.max = this.$util.fmtDate(this.nowDate);
        this.tradeTime = "1";
    },
    methods: {
        openContract (val) {
            this.signArray = [];
            let _this = this;
            _this.$util.request("acct/contract/img", { contractno: val }, "POST").then(res => {
                if (res.data && res.data[0].imgList && res.data[0].imgList !== "[]") {
                    _this.signArray = res.data[0].imgList.slice(1,-1).split(",");
                } else {
                    _this.$message({
                        type: "warning",
                        message: "未查找到有效合同文件"
                    });
                    return false;
                }
            });
        },
        formatterDate (row, column, value) {
            return this.$util.fmtDate(value);
        },
        formatterName (row, column, value) {
            if (isTargetFundBusiness(row)) {
                return row.targetfundname + "(" + row.targetfundcode + ")";
            }
            return row.fundname + "(" + row.fundcode + ")";
        },
        formatterNameCC (row, column, value) {
            return value ? row.targetfundname + "(" + row.targetfundcode + ")" : "--";
        },
        formatterDisname (row, column, value) {
            if (row.sourceflag === "2") {
                return row.distributorname ? row.distributorname : "--";
            }
            return value ? (this.$cache.getDict("110070",value) ? this.$cache.getDict("110070",value) : "--") : "--";
        },
        formatterTran (row, column, value) {
            if (value === "20") {
                if (row.businesscode_ack === "120") {
                    return "认购申请";
                }
                if (row.businesscode_ack === "130") {
                    return "认购结果";
                }
            }
            return this.$cache.getDict("130010", value);
        },
        formatterAmount (row, column, value) {
            if (row.sourceflag === "2") {
                return "--";
            }
            return row.appamount > 0 ? (this.$util.fmtNum(row.appamount)) : (this.$util.fmtNum(row.appvol));
        },
        formatterCfmAmount (row, column, value) {
            return row.cfmamount > 0 ? (this.$util.fmtNum(row.cfmamount)) : (this.$util.fmtNum(row.cfmevol));
        },
        formatterCfmStatus (row, column, value) {
            return row.cfmstatus === "0" ? "成功" : (row.cfmstatus === "1" ? "失败" : this.transAppstatus(row.appstatus));
        },
        transAppstatus(appstatus){
            if(appstatus === "00" || appstatus === "01" || appstatus === "02"){
                return "待确认";
            }
            return this.$cache.getDict("110003", appstatus);
        },
        // 展示详情
        detail (v) {
            const _this = this;
            this.$util.request("trade/order/detail", { appsheetserialno: v }).then(res => {
                if (res.data) {
                    _this.fundDetail = res.data[0];
                    _this.detailVisible = true;
                    if (_this.fundDetail.zqcontractflag === "1") {
                        _this.openContract(_this.fundDetail.contractno);
                    }
                }
            });
        },
        // 指定每行row-key
        getRowKeys (row) {
            return row.appsheetserialno;
        },
        // 撤单操作确认
        cancelConfirm () {
            const _this = this;
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    let _pwd = "";
                    if (_this.isPwdCheck) {
                        _pwd = _this.$util.enc(_this.ruleForm.tradepwd);
                    }
                    this.$util.request("trade/cancel", { orderid: _this.cancelFund.appsheetserialno, tradepwd: _pwd }, "POST").then(res => {
                        if (res.data) {
                            _this.dialogVisible = false;
                            _this.doAction();
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        // 获取撤单基金信息
        cancelTrade (val) {
            const _c = this.fund.filter(item => {
                return item.appsheetserialno === val;
            })[0];
            if (_c) {
                this.cancelFund = _c;
                this.dialogVisible = true;
            }
        },
        // 获取用户选中时间区间
        dateInterval (val) {
            // convert "YYYY-MM-DD" to "YYYYMMDD"
            this.beginDate = this.$util.isEmpty(val.beginDate) ? "" : val.beginDate.replace(/-/g, "");
            this.endDate = this.$util.isEmpty(val.endDate) ? "" : val.endDate.replace(/-/g, "");
        },
        // 展开指定行
        expendTable (row) {
            if (row.appsheetserialno !== this.expands[0]) {
                this.expands = [];
                this.expands.push(row.appsheetserialno);
            } else {
                this.expands = [];
            }
        },
        pageRefresh (val) {
            this.pageoffset = val - 1;
            this.doAction();
        },
        sizeReset (val) {
            this.curPage = 1;
            this.pageoffset = "0";
            this.pagecount = val + "";
            this.doAction();
        },
        showAll(evt) {
            let target = evt.target;
            if (target) {
                if (target.nodeName === "SPAN") {
                    target = evt.target.parentNode;
                }
                target.blur();
            }
            this.isShowAll = !this.isShowAll;
            if (this.isShowAll) {
                this.pageLayout = "total, slot";
            } else {
                this.pageLayout = "total, slot, sizes, prev, pager, next";
            }
            this.curPage = 1;
            this.pageoffset = "0";
            this.doAction();
        },
        // 搜索基金
        searchFund () {
            //||
            // if(this.$util.isEmpty(this.beginDate) ){
            //     let _m = "请输入完整的日期范围";
            //     this.$alert(_m,"日期提示");
            //     this.fund = [];
            //     this.allPage = 0;
            //     return;
            // }
            // eslint-disable-next-line no-empty
            if(this.$util.isEmpty(this.endDate)){
                this.endDate = format(new Date(), "YYYYMMDD");
            }
            this.doAction(this.searchText);
        },
        // 获取基金信息
        getFund (val, cb) {
            const _x = {
                begindate: this.beginDate,
                enddate: this.endDate,
                businesscode: this.tradeCate,
                sourceflag: this.fundFrom,
                keyword: val || this.searchText,
                pagecount: cb ? "1000" : this.pagecount,
                pageoffset: ((val ? "0" : this.pageoffset) * this.pagecount).toString(),
                filterstatus: "04", //过滤废单
                ispage: this.isShowAll ? "0" : ""
            };
            this.$util.request("trade/order/list", _x, "GET", true).then(res => {
                if (res.data) {
                    if (!cb) {
                        this.fund = res.data;
                        this.allPage = res.alllength;
                    } else {
                        cb.call(this, res.data);
                    }
                }
            });
        },
        //请求限制
        actionLimit(){
            const _this = this;
            this.query = setTimeout(()=>{
                _this.index = 0;
                clearTimeout(this.query);
            },2000);
            if(this.query !== null){
                clearTimeout(this.query);
                this.index++;
            }
            if(this.index > 3){
                this.$alert("您请求太频繁，请等待一会！", "访问提示");
                this.query = setTimeout(()=>{
                    _this.index = 0;
                    clearTimeout(this.query);
                },10000);
                return false;
            }
            return true;
        },
        // 对基金频繁查询请求做处理
        doAction (val, cb) {
            // this.actionLimit();
            this.fund = [];
            this.allPage = 0;
            const _this = this;
            if (cb) {
                val = this.$util.filterCode(val);
                this.searchText = val;
                if (val.length < 1) {
                    cb.call(this, []);
                    return false;
                }
            }
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                _this.getFund(val, cb);
            }, 100);
        },
        // 搜索选项关闭处理
        handleClose (val) {
            const _x = this.tradeCateArr.filter(risk => {
                return risk.text === val;
            });
            if (_x.length > 0) {
                this.tradeCate = "";
            } else {
                this.tradeTime = "";
            }
        },
        downloadPdf(val) {
            window.open(val);
        }
    }
};
</script>
<style lang="scss">
.view-trade-record {
    /*自定义时间控件*/
    .custom-time {
        display: inline-block;
        vertical-align: middle;
        .comp-date-picker {
            width: auto;
        }
        .el-button {
            min-width: 100px;
            padding: 8px 15px;
            margin-left: 13px;
        }
    }
    .redemp-btn{margin-left: 3%;}
    .info-tips {
        .two-cols-form .el-form-item__content {
            .el-input {
                width: 70%;
            }
        }
        .prompt-info {
            .el-icon-warning {
                margin-right: 8px;
                vertical-align: middle;
            }
            span {
                vertical-align: middle;
            }
        }
    }
    .trade-detail-dialog {
        .trade-detail-form {
            max-height: none;
            padding-bottom: 12px;
        }
    }
    .remit-infos{
        text-align: right;
        cursor: pointer;
    }
    .contract-btn {
        color: #fff;
        background-color: rgb(255, 187, 0);
    }
    .contract-download-btn {
        color: #fff;
        background-color: rgb(230, 0, 18);
    }
}
</style>
